import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
export const HardLimitSchema = z.object({
    hardMax: z.number().int().min(1),
});
export const UpdateGenerationSettingsSchema = z
    .object({
    limits: z
        .object({
        modules: HardLimitSchema.optional(),
        topicsPerModule: HardLimitSchema.optional(),
        lessonsPerTopic: HardLimitSchema.optional(),
        learnStepsPerLesson: HardLimitSchema.optional(),
        reviseStepRatio: z.number().min(0.1).max(2).optional(),
        reviseStepsHardMax: z.number().int().min(1).optional(),
    })
        .optional(),
    bloomsEscalation: z.record(z.string(), z.number().int().min(1)).optional(),
    defaults: z
        .object({
        defaultProgressionType: z.enum(['lesson', 'topic', 'module']).optional(),
    })
        .optional(),
})
    .openapi('UpdateGenerationSettings');
// Response schemas for GET endpoints
export const GenerationSettingsResponseSchema = z
    .object({
    limits: z
        .unknown()
        .nullable()
        .openapi({ description: 'Module/topic/lesson generation limits' }),
    defaults: z
        .unknown()
        .nullable()
        .openapi({ description: 'Default progression type' }),
})
    .openapi('GenerationSettingsResponse');
export const AiModeSchema = z.enum(['live', 'testing']).openapi('AiMode');
export const UpdateAiModeSchema = z
    .object({
    mode: AiModeSchema,
})
    .openapi('UpdateAiMode');
export const AiModeResponseSchema = z
    .object({
    mode: AiModeSchema,
})
    .openapi('AiModeResponse');
//# sourceMappingURL=settings.schema.js.map